// src/pages/StudentAnalyticsPage.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import StaffSidebar from "../components/StaffSidebar";
import "../assets/css/analytics.css";

const isProduction = process.env.NODE_ENV === "production";
const API = isProduction
  ? process.env.REACT_APP_API_BASE_URL
  : "http://localhost:3003";

export default function StudentAnalyticsPage() {
  const programme = localStorage.getItem("programme") || "";
  const [level, setLevel] = useState("");
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

useEffect(() => {
  if (!level) return;

  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  axios
    .get(`${API}/api/staff/courses`, {
      params: { username, role, level },
    })
    .then((res) => {
      console.log("Courses:", res.data);
      setCourses(res.data || []);
    })
    .catch((err) => {
      console.error("Courses error:", err);
      setCourses([]);
    });
}, [level]);

  const loadAnalytics = async () => {
    if (!selectedCourse) return;

    try {
      setLoading(true);
      const res = await axios.get(`${API}/api/analytics/course`, {
        params: {
          courseId: selectedCourse,
        },
      });

      setStats(res.data);
    } catch (err) {
      console.error(err);
      alert("Failed to load analytics");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="analytics-page">
      <StaffSidebar />

      <main className="analytics-main">
        <h1>Student Analytics Dashboard</h1>

        {/* Filters */}
        <div className="analytics-filters">
          <select value={level} onChange={(e) => setLevel(e.target.value)}>
            <option value="">Select Level</option>
            <option value="ND1">ND1</option>
            <option value="ND2">ND2</option>
            <option value="HND1">HND1</option>
            <option value="HND2">HND2</option>
          </select>

          <select
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
          >
            <option value="">Select Course</option>
            {courses.map((c) => (
              <option key={c.CourseID} value={c.CourseID}>
                {c.CourseCode} - {c.CourseTitle}
              </option>
            ))}
          </select>

          <button onClick={loadAnalytics} className="btn-load">
            Load Analytics
          </button>
        </div>

        {loading && <p>Loading analytics...</p>}

        {stats && (
          <>
            {/* Summary Cards */}
            <div className="analytics-cards">
              <div className="card">
                <h3>Pass Rate</h3>
                <p>{stats.passRate}%</p>
              </div>

              <div className="card">
                <h3>Fail Rate</h3>
                <p>{stats.failRate}%</p>
              </div>

              <div className="card">
                <h3>Class Average</h3>
                <p>{stats.averageScore}</p>
              </div>
            </div>

            {/* Course Trend Table */}
            <div className="analytics-table">
              <h2>Performance Trend</h2>
              <table>
                <thead>
                  <tr>
                    <th>Session</th>
                    <th>Average Score</th>
                    <th>Pass Rate</th>
                  </tr>
                </thead>
                <tbody>
                  {stats.trends.map((t, i) => (
                    <tr key={i}>
                      <td>{t.session}</td>
                      <td>{t.avgScore}</td>
                      <td>{t.passRate}%</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </main>
    </div>
  );
}